/* eslint-disable
    func-names,
    no-bitwise,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
const service = function () {
  class Uuid {
    generate() {
      let d = new Date().getTime();
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now(); // use high-precision timer if available
      }

      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        if (c === 'x') {
          return r.toString(16);
        }
        return ((r & 0x3) | 0x8).toString(16);
      });
      return uuid;
    }
  }

  return new Uuid();
};
module.exports = service;
